import { createContext, useContext, useMemo } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { getNDA, addNDA, updateNDA } from "../../api/nda-details";
import useToaster from "../../components/alert";

const NdaContext = createContext();

export const NdaProvider = ({ children }) => {
  const toaster = useToaster();

  const getNdaQuery = useQuery({
    queryKey: ["nda"],
    queryFn: getNDA,
  });

  const addNdaQuery = useMutation({ mutationFn: addNDA });
  const updateNdaQuery = useMutation({ mutationFn: updateNDA });

  const initialValues = useMemo(() => {
    const ndaData = getNdaQuery?.data?.data?.[0] || {};

    return {
      heading: ndaData?.heading || "",
      desc: ndaData?.desc || "",
      nda_files: ndaData?.nda_files || [{ file_name: "", file: "" }],
    };
  }, [getNdaQuery]);

  const handleSubmit = async (values) => {
    const payload = {
      heading: values?.heading || "",
      desc: values?.desc || "",
      nda_files: values?.nda_files,
    };

    const ndaData = getNdaQuery?.data?.data?.[0] || {};

    if (ndaData._id) {
      payload.id = ndaData._id;
      updateNdaQuery.mutate(payload, {
        onSuccess: () => {
          toaster.success("Success", "Data is updated successfully.");
        },
      });
      return;
    }
    addNdaQuery.mutate(payload, {
      onSuccess: () => {
        toaster.success("Success", "Data is added successfully.");
      },
    });
  };

  return <NdaContext.Provider value={{ initialValues, handleSubmit, getNdaQuery }}>{children}</NdaContext.Provider>;
};

export const useNdaProvider = () => {
  return useContext(NdaContext);
};
